<template>
    <div class="answer_sheet">
        <div class="answer_top">
            <div class="answer_title">试卷信息</div>
            <div class="flex FlexBetween mt-5">
                <div class="flex exam_info">
                    <div class="exam_label">题数：</div>
                    <div class="exam_value flex-1 toverflow mar_left_10">
                        {{ testExamInfo.questionCount }}
                    </div>
                </div>
                <div class="flex exam_info">
                    <div class="exam_label">总分：</div>
                    <div class="exam_value flex-1 toverflow mar_left_10">
                        {{ testExamInfo.fullScore }}
                    </div>
                </div>
            </div>
        </div>
        <div class="topic_list mar_top_20">
            <div class="topic_one mar_bottom_20" v-for="(item, index) in topicList" :key="index">
                <div class="topic_type">{{ item.topicType }}</div>
                <div class="topic_sub flex FlexWrap" v-if="!testExamInfo.isShowScoring">
                    <div class="answer_block mar_top_10 cursor_pointer" v-for="(sitem, sindex) in item.subList"
                        :key="sindex" :class="[
                            sitem.status == 0
                                ? 'incomplete_progress'
                                : sitem.status == 1
                                    ? 'complete_progress'
                                    : 'current_progress',
                        ]">
                        {{ sitem.topicNum }}
                    </div>
                </div>
                <div class="topic_sub flex FlexWrap" v-if="testExamInfo.isShowScoring">
                    <div class="answer_block mar_top_10 cursor_pointer" v-for="(sitem, sindex) in item.subList"
                        :key="sindex" :class="[
                            sitem.isCorrect == 1
                                ? 'complete_progress'
                                : sitem.isCorrect == 2
                                    ? 'wrong_progress'
                                    : 'current_progress',
                        ]">
                        {{ sitem.topicNum }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
export default {
    name: "GjkcH5PaperAnswerSheet",
    computed: {
        ...mapState({

        }),
    },
    components: {},
    props: {
        testExamInfo: {}
    },
    emits: [], // 显式声明事件
    inject: [],
    watch: {
        testExamInfo: {
            handler() {
                this.organizeQuestionType();
            },
            deep: true,
        },
    },
    unmounted() {

    },

    data() {
        return {
            examInfo: {
                name: "",
                chapter: "",
                number: 20,
                duration: "",
                fullMark: 100,
            },
            topicList: [],
            finalScore: 0, // 总分
            paperCommitBackInfo: {},  // 闯关提交反馈结果
            loading: {},
        };
    },

    mounted() {
        this.organizeQuestionType();
    },

    methods: {
        // 题型整理归纳
        organizeQuestionType() {
            this.topicList = [];
            if (this.$Tools.empty(this.testExamInfo)) return;
            const map = ["一", "二", "三", "四", "五", "六", "七", "八", "九", "十", '十一', '十二', '十三', '十四', '十五', '十六', '十七', '十八', '十九', '二十', '二十一', '二十二', '二十三', '二十四', '二十五', '二十六', '二十七', '二十八', '二十九', '三十'];
            this.testExamInfo.paperContext.forEach((item) => {
                let topicInfo = {
                    topicType: "",
                    subList: [],
                    questionTypeId: "",
                };
                item.questions.forEach((sitem) => {
                    let isInProgress = 0; // 1已完成，2，进行中，0未完成
                    if (sitem.questionContext?.isFinish) {
                        isInProgress = 1;
                    } else {
                        isInProgress = 0;
                    }
                    // 判断题目是不是当前题目
                    if (sitem.questionNumber == this.testExamInfo.currentQuestionId) {
                        isInProgress = 2;
                    }
                    // 查询题型是否已存在，存在则直接丢题目，否则创建题型列
                    const currentIndex = this.topicList.findIndex(
                        (ssitem) => item.questionTypeId == ssitem.questionTypeId
                    );
                    if (currentIndex != -1) {
                        this.topicList[currentIndex].subList.push({
                            ...sitem,
                            topicNum: sitem.questionNumber,
                            status: isInProgress,
                        });
                    } else {
                        // if (sitem.questionTypeId == 1) {
                        //   topicInfo.topicType = `${map[this.topicList.length]}、选择题`;
                        // } else if (sitem.questionTypeId == 2) {
                        //   topicInfo.topicType = `${map[this.topicList.length]}、多选题`;
                        // } else if (sitem.questionTypeId == 4) {
                        //   topicInfo.topicType = `${map[this.topicList.length]}、判断题`;
                        // } else if (sitem.questionTypeId == 6) {
                        //   topicInfo.topicType = `${map[this.topicList.length]}、排序题`;
                        // } else if (sitem.questionTypeId == 3) {
                        //   topicInfo.topicType = `${map[this.topicList.length]}、填空题`;
                        // }
                        topicInfo.topicType = `${map[this.topicList.length]}、${item.questionTypeName
                            }`;
                        topicInfo.questionTypeId = sitem.questionTypeId;
                        topicInfo.subList.push({
                            ...sitem,
                            topicNum: sitem.questionNumber,
                            status: isInProgress,
                        });
                        this.topicList.push(topicInfo);
                    }
                });
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.answer_sheet {
    width: 330px;
    // height: 847px;
    background: #ffffff;
    border-radius: 10px;
    padding: 15px 20px;
    box-sizing: border-box;

    .answer_top {
        padding-bottom: 10px;
        border-bottom: 1px dashed #dedede;

        .answer_title {
            font-weight: bold;
            font-size: 20px;
            color: #333333;
            text-align: center;
        }

        .exam_info {
            box-sizing: border-box;
            padding-left: 10px;
            line-height: 30px;
            font-size: 14px;
            // font-weight: 600;

            .exam_label {
                color: #606060;
            }

            .exam_value {
                color: #606060;

                .notes {
                    font-size: 12px;
                    color: rgb(153, 153, 153);
                }
            }
        }

        .testExam_score {
            font-size: 14px;
            color: #FD673B;

            .testExam_score_value {
                font-weight: 500;
                font-size: 32px;
                color: #FD673B;
            }
        }

        .homework_score_icon {
            width: 49px;
            height: 21px;
        }

        .marker_info {
            background: #F6FAFF;
            border-radius: 10px;
            font-size: 14px;
            color: #111111;

            .marker_info_content {
                width: 100%;
                overflow-wrap: anywhere;
            }

            .comments_icon {
                width: 62px;
                height: 27px;
            }
        }

        .marker_reviewer {
            .reviewer_label {
                width: 90px;
                font-size: 16px;
                color: #999999;
            }

        }
    }

    .progress_classify {
        .classify_one {
            color: #333333;
            // font-weight: 600;
        }
    }

    .topic_list {
        .topic_one {
            .topic_type {
                color: #333333;
                line-height: 24px;
            }

            .topic_sub {
                .answer_block {
                    text-align: center;
                    line-height: 24px;
                    margin-right: 10px;
                }
            }
        }
    }

    .save_btn {
        width: 220px;
        height: 42px;
        border-radius: 21px;
        border: 1px solid #13d6aa;
        font-size: 18px;
        color: #13d6aa;
        text-align: center;
        line-height: 42px;
        margin: 80px auto 10px;
    }

    .commit_btn {
        width: 220px;
        height: 42px;
        background: #13d6aa;
        border-radius: 21px;
        font-size: 18px;
        text-align: center;
        line-height: 42px;
        color: #ffffff;
        margin: 10px auto;
    }

    .attention_text {
        font-size: 14px;
        color: #999999;
        margin: 15px auto;
        text-align: center;
    }
}

.complete_progress {
    width: 24px;
    height: 24px;
    background: rgba(0, 199, 88, 0.2);
    border-radius: 4px;
    border: 1px solid #00c758;
    color: #00c758;
}

.incomplete_progress {
    width: 24px;
    height: 24px;
    background: rgba(225, 225, 225, 0.2);
    border-radius: 4px;
    color: #999999;
    border: 1px solid #999999;
}

.current_progress {
    width: 24px;
    height: 24px;
    background: rgba(103, 139, 255, 0.2);
    border-radius: 4px;
    border: 1px solid #3a74f7;
    color: #3a74f7;
}

.wrong_progress {
    width: 24px;
    height: 24px;
    background: rgba(255, 20, 20, 0.23);
    border-radius: 4px;
    border: 1px solid #ff1414;
    color: #ff1414;
}

.marker_info {
    .markerComment {
        border: 1px solid #666;
        border-radius: 10px;
    }
}
</style>
